import { Prose } from '../../components/Prose'
import { useState } from 'react'
import { api } from '../../api/client'

export function LoginScreen({ onSuccess }: { onSuccess: () => void }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await api.login(email, password)
      onSuccess()
    } catch {
      // Hata mesajı bilerek genel: "böyle bir e-posta yok" demek,
      // hangi adreslerin kayıtlı olduğunu sızdırır.
      setError('E-posta veya parola hatalı.')
      setBusy(false)
    }
  }

  return (
    <div className="center">
      <form className="card" style={{ maxWidth: 380, width: '100%' }} onSubmit={submit}>
        <h1 style={{ fontSize: 22 }}>Kilo Takip</h1>
        <p className="sub" style={{ margin: '6px 0 18px' }}>Devam etmek için giriş yap.</p>

        <div style={{ marginBottom: 12 }}>
          <label className="f">E-posta</label>
          <input type="email" value={email} autoComplete="username" required autoFocus
                 onChange={(e) => setEmail(e.target.value)} />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label className="f">Parola</label>
          <input type="password" value={password} autoComplete="current-password" required
                 onChange={(e) => setPassword(e.target.value)} />
        </div>

        {error && (
          <p style={{ color: 'var(--crit)', fontSize: 13.5, margin: '0 0 12px' }}>{error}</p>
        )}

        <button className="primary" type="submit" disabled={busy} style={{ width: '100%' }}>
          {busy ? 'Kontrol ediliyor…' : 'Giriş yap'}
        </button>

        <Prose className="note" style={{ textAlign: 'center' }}>
          Hesabın yoksa yöneticiden istemen gerekiyor — burada kayıt yok.
        </Prose>
      </form>
    </div>
  )
}
